import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { Report } from '../shared/report.model';
import { ReportService } from '../shared/report.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../user-dashboard/shared/user.service';
import { Region } from '../../user-dashboard/shared/region.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-report-configuration',
  templateUrl: './report-configuration.component.html',
  styleUrls: ['./report-configuration.component.scss']
})
export class ReportConfigurationComponent implements OnInit {

  reports: Report[] = [];
  pageReports: Report[] = [];
  homeReport: Report;

  constructor(private navigation: NavigationService,
              private loader: LoaderService,
              private reportsService: ReportService,
              private userService: UserService,
              private toastr: ToastrService,
              private translate: TranslateService) {
    this.loader.startLoad(false);

    this.userService.getHomeReport()
      .subscribe( (report: Report) => {
        this.homeReport = report
      });

    this.reportsService.getAll()
      .pipe(
        finalize(() => this.loader.stopLoad()))
      .subscribe((reports: Report[]) => this.reports = reports);
  }

  ngOnInit() {
  }

  goToNewReport() {
    this.navigation.reportsConfiguration()
      .create()
      .go();
  }

  updateReport(id: string) {
    this.navigation.reportsConfiguration()
      .edit(id)
      .go();
  }

  changeHomeReport() {
    this.loader.startLoad();
    this.reportsService.changeHomeReport(this.homeReport)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(() => {
        this.toastr.success(this.translate.instant('administration.reports-configuration.successes.home-update'));
    }, (error: HttpErrorResponse) => {
      this.toastr.error(error.error.message || this.translate.instant('administration.reports-configuration.errors.home-update'));
    });
  }

  equalsRegionsId(r1: Region, r2: Region) {
    return r1 && r2 && r1.id === r2.id;
  }

}
